import { Link } from "components/icons/generated";
import Button from "ds/components/Button";
import { ButtonIconProps } from "ds/components/ButtonIcon";
import Tooltip from "ds/components/Tooltip";
import BlueprintsFeatureGateTooltip from "views/Account/Blueprints/FeatureGate/Tooltip";
import { BlueprintActions } from "views/Account/Blueprints/FeatureGate/types";

import useShare from "./useShare";

type BlueprintShareButtonProps = {
  blueprintId: string;
  variant: ButtonIconProps["variant"];
  size: ButtonIconProps["size"];
};

const BlueprintShareButton = ({ blueprintId, variant, size }: BlueprintShareButtonProps) => {
  const { onShare } = useShare(blueprintId);

  return (
    <BlueprintsFeatureGateTooltip
      action={BlueprintActions.CreateStack}
      on={({ isDisabled, ...props }) => (
        <Tooltip
          disableAriaLabel={isDisabled}
          on={(tooltipProps) => (
            <Button
              {...props}
              {...tooltipProps}
              startIcon={Link}
              onPress={onShare}
              variant={variant}
              size={size}
              disabled={isDisabled}
            >
              Copy link
            </Button>
          )}
        >
          Copy link to proceed with stack creation via blueprint
        </Tooltip>
      )}
    />
  );
};

export default BlueprintShareButton;
